var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { callGraphQL } from '../../common/common';
import { feedbackByCategoryByCreatedAt } from '../../../graphql/queries';
/**
 * List's all feedback records for a category. Only users within the Employee Cognito group can call this method.
 * @param category  Category to list
 * @param optParams
 */
export function listFeedback(category, optParams) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = Object.assign(Object.assign({}, optParams), { category, sortDirection: 'DESC' });
        return callGraphQL(feedbackByCategoryByCreatedAt, params).then((res) => {
            var _a, _b, _c, _d;
            return {
                items: (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.feedbackByCategoryByCreatedAt) === null || _b === void 0 ? void 0 : _b.items,
                nextToken: (_d = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.feedbackByCategoryByCreatedAt) === null || _d === void 0 ? void 0 : _d.nextToken
            };
        });
    });
}
